var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bi-Bread_box"},[_c('div',{staticClass:"bi-Bread_back",on:{"click":_vm.handleBack}},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" 返回 ")]),_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.titles),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }